<template>
  <header class="header position-relative d-flex align-center">
    <div class="container header__container w100">
      <div class="header__text position-relative">
        <div class="header__title text-medium">Учасників Гранд Пікніка <br> обираєш саме ти</div>
        <div class="header__description">Хочеш відвідати з друзями-колегами унікальну подію Нової пошти? Тоді швидше номінуй для участі їх та себе</div>
        <a v-scroll-to="'#mainForm'" class="button button-success header__button text-center">Номінувати колегу</a>
      </div>
    </div>
    <img src="./../assets/images/header/header_boy.png" alt="Boy" class="header__img position-absolute">
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
}
</script>

<style scoped lang="scss">
@use 'sass:math';
@import "../assets/styles/parts/variables";
@import "../assets/styles/parts/mixins";

  .header {
    z-index: 4;
    overflow: hidden;
    @media (min-height: 880px) {
      height: 100vh;
    }
    &:before {
      content: '';
      background-image: url("#{$imgpath}header/header_conf.png");
      -webkit-background-size: contain;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: 0 0;
      width: sm(375);
      height: sm(305);
      position: absolute;
      left: 0;
      top: 0;
      z-index: 4;
      @include _1024 {
        width: sl(1179);
        height: sl(880);
        left: 50%;
        transform: translateX(sl(-219));
      }
      @include _1920 {
        width: 1179px;
        height: 880px;
        transform: translateX(-219px);
      }
      @media (min-height: 880px) {
        height: 100%;
      }
    }
    &__container {
      @media (max-width: 767px) {
        padding-left: sm(24);
        padding-right: sm(24);
      }
    }
    &__text {
      padding-top: sm(104);
      padding-bottom: sm(375);
      z-index: 6;
      @include _1024 {
        max-width: sl(867);
        padding-top: sl(240);
        padding-bottom: sl(274);
      }
      @include _1920 {
        max-width: 867px;
        padding-top: 240px;
        padding-bottom: 274px;
      }

    }
    &__title {
      line-height: math.div(76.8,64);
      font-size: sm(32);
      padding-bottom: sm(16);
      @include _1024 {
        font-size: sl(64);
        padding-bottom: sl(24);
      }
      @include _1920 {
        font-size: 64px;
        padding-bottom: 24px;
      }
    }
    &__description {
      font-size: sm(16);
      line-height: math.div(38.4,24);
      padding-bottom: sm(32);
      @include _1024 {
        font-size: sl(24);
        padding-bottom: sl(40);
      }
      @include _1920 {
        font-size: 24px;
        padding-bottom: 40px;
      }
    }

    &__img {
      z-index: 5;
      left: 50%;
      width: sm(375);
      height: sm(375);
      transform: translateX(-50%);
      bottom: 0;
      object-fit: contain;
      object-position: center;
      @include _1024 {
        width: sl(880);
        height: sl(880);
        transform: translateX(sl(-50));
        top: 0;
        bottom: auto;
      }
      @include _1920 {
        width: 880px;
        height: 880px;
        transform: translateX(-50px);
      }
      @media (min-height: 880px) {
        height: 100%;
      }
    }

    &__button {
      padding: sm(14) sm(32);
      font-size: sm(14);
      border-radius: sm(8);
      line-height: math.div(19.6, 14);
      margin-bottom: sm(16);
      display: block;
      @include _1024 {
        padding: sl(24) sl(32);
        font-size: sl(24);
        border-radius: sl(8);
        line-height: 1;
        margin-bottom: 0;
        display: inline-block;
      }
      @include _1920 {
        padding: 24px 32px;
        font-size: 24px;
        border-radius: 8px;
      }
    }
  }

</style>
